export default [{ label: 'Network Availability', link: '/v4/core/network-availability' }];
